import { createPath, To } from "react-router";

import {
  getSelectedSitesQueryParam,
  replaceSelectedSitesInParams,
} from "./selectedSitesHelper";

export function withGlobalParams(to: To, sites: string[]) {
  const normalizedTo = typeof to === "string" ? to : createPath(to);
  const url = new URL(normalizedTo, window.location.origin);
  const queryParam = getSelectedSitesQueryParam();

  if (!url.searchParams.has(queryParam)) {
    const nextParams = replaceSelectedSitesInParams(url.searchParams, sites);
    url.search = nextParams.toString();
  }

  return `${url.pathname}${url.search}${url.hash}`;
}
